import { IProfile } from '@assetmark/profile/dist/profileComponent';
import { defaultProfileData } from '../../constants/data.constant';
import { TLeadProfileResponse } from '../../models/lead-profile-response';
import { TLeadStrategyInfoResponse } from '../../models/lead-strategy-info-response';
import { TScreenType } from '../../models/screen-type';
import { LeadAction } from './lead.action';
import {
	LEAD_SCREEN,
	LEAD_PROFILE,
	LEAD_PAGE,
	LEAD_RETIREMENT_AGE,
	LEAD_MONTHLY_INCOME,
	LEAD_RETIREMENT_INCOME,
	LEAD_ANNUAL_SAVING,
	LEAD_SKIP_GOAL_INFO,
	LEAD_INVESTER_TARGET,
	UPDATE_LEAD_DATA,
	UPDATE_NAV_STATE,
	UPDATE_ABOUT_YOU_STATE,
} from './lead.constant';
import { TInvestorNavState, TGoal } from './lead.model';

export type LeadContextState = {
	agentId: string;
	leadProfileId: string;
	leadStrategyId: string;
	updateLeadData: (lead: TLeadProfileResponse) => void;
	screen: TScreenType;
	setScreen: (screen: TScreenType)=> void;
	leadProfile: IProfile;
	setLeadProfile: (profile: IProfile) => void;
	investorNavState: TInvestorNavState;
	updateNavState: (investorNavState: TInvestorNavState) => void;
	goals: TGoal;
	setGoals: (type: any, goal: TGoal) => void;
	setSkipGoal: (type: any, val: string) => void;
	updateAboutYouState: (lead: TLeadStrategyInfoResponse) => void;
};

export const initialState: LeadContextState = {
	agentId: '',
	leadProfileId: '',
	leadStrategyId: '',
	updateLeadData: (lead: TLeadProfileResponse) => {},
	screen: "about",
	setScreen: (screen: TScreenType) => {},
	leadProfile: defaultProfileData,
	setLeadProfile: (profile: IProfile) => {},
	
	investorNavState: {
		aboutYouVisited: true,
		goalsVisited: false,
		riskVisited: false,
		analysisVisited: false,
		goalsActiveState: 'About You',
	},
	updateNavState: (investorNavState: TInvestorNavState) => {},
	goals: {
		GoalType: 0,
		Amount: 0,
		retirementAge: 0,
		TargetAmount: 0,
		TargetYear: 0,
		MonthlyIncome: 0,
		MonthlyIncomeToRetirePercent: 0,
		OtherRetirementIncomes: [{ Id: '', IncomeSourceTypeId: 0 }],
		NetRetirementMonthlyIncome: 0,
		AnnualSavings: 0,
	},
	
	setGoals: (type: any, goal: TGoal) => {
		goal;
	},
	setSkipGoal: (type: any, val: string) => {
		val;
	},

	updateAboutYouState: (lead: TLeadStrategyInfoResponse) => {}
};

export function leadContextReducer(state: LeadContextState, action: LeadAction) {
	let newState: any;
	switch (action.type) {
		case UPDATE_ABOUT_YOU_STATE: {
			return {
				...state,
				leadProfile: action.payload
			};
		}
		case UPDATE_NAV_STATE: {
			return {
				...state,
				investorNavState: action.payload
			};
		}
		case UPDATE_LEAD_DATA: {
			return {
				...state,
				leadProfile: action.payload.profile,
				agentId: action.payload.agentId,
				leadProfileId: action.payload.leadProfileId,
				leadStrategyId: action.payload.leadStrategyId,
			};
		}
		case LEAD_SCREEN: {
			return {
				...state,
				screen: action.payload,
			};
		}
		case LEAD_PROFILE: {
			return {
				...state,
				leadProfile: action.payload,
			};
		}
		case LEAD_RETIREMENT_AGE:
			newState = Object.assign({}, state);
			const calculatedBirthYear = new Date().getFullYear() - newState.leadProfile.Investor.Age;
			const targetYear = Number(action.payload) + calculatedBirthYear;
			newState.goals = { ...state.goals, retirementAge: action.payload, TargetYear: targetYear, BirthYear: calculatedBirthYear  };
			return newState;
		case LEAD_MONTHLY_INCOME:
			newState = Object.assign({}, state);
			newState.goals = { ...state.goals, MonthlyIncome: action.payload };
			return newState;
		case LEAD_RETIREMENT_INCOME:
			newState = Object.assign({}, state);
			newState.goals = {
				...state.goals,
				MonthlyIncome: action.payload.MonthlyIncome,
				MonthlyIncomeToRetirePercent: action.payload.MonthlyIncomeToRetirePercent,
				NetRetirementMonthlyIncome: action.payload.NetRetirementMonthlyIncome,
				OtherRetirementIncomes: action.payload.OtherRetirementIncomes,
			};
			return newState;
		case LEAD_ANNUAL_SAVING:
			newState = Object.assign({}, state);
			newState.goals = { ...state.goals, AnnualSavings: action.payload };
			newState.investorNavState = {
				aboutYouVisited: true,
				goalsVisited: true,
				riskVisited: false,
				analysisVisited: false,
				goalsActiveState: 'Risk Profile',
			};
			return newState;
		case LEAD_PAGE: {
			return {
				...state,
				page: action.payload,
			};
		}
		case LEAD_SKIP_GOAL_INFO:
			newState = Object.assign({}, state);
			newState.investorNavState = {
				aboutYouVisited: true,
				goalsVisited: true,
				riskVisited: false,
				analysisVisited: false,
				goalsActiveState: 'Risk Profile',
			};
			return newState;
		case LEAD_INVESTER_TARGET:
			newState = Object.assign({}, state);
			newState.goals = {
				...state.goals,
				GoalType: action.payload.GoalType,
				TargetYear: action.payload.TargetYear,
				AnnualSavings: action.payload.AnnualSavings,
				TargetAmount: action.payload.TargetAmount,
			};
			newState.investorNavState = {
				aboutYouVisited: true,
				goalsVisited: true,
				riskVisited: false,
				analysisVisited: false,
				goalsActiveState: 'Risk Profile',
			};
			return newState;
		default: {
			throw new Error(`Unhandled action type: ${action}`);
		}
	}
}
